<template>
  <div class="noPermission">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div class="page-noPermission">
          <div class="img">
            <img src="../../assets/images/img-noPermission.png" alt />
          </div>
          <p class="title">{{ $t("noPermission.a1") }}</p>
        </div>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import axios from "axios";
export default {
  name: "noPermission",
  data() {
    return {
      openMenu: ["1"],
      time: 3,
    };
  },
  components: {
    PageNav,
  },
  created() {
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.staffer_id = this.$Tool.getStorage("staffer_id");
    this.Countdown();
  },
  mounted() {},
  methods: {
    ComTokenApi() {
      this.$http.ComTokenApi({}).then((res) => {
        if (res.data.code === 200) {
          let token = res.data.token;
          this.getUserStatusInfo(token);
        }
      });
      // axios
      //   .get(`${this.$Urls.wpcApiUrl}/Login/ComTokenApi`, {
      //     params: {}
      //   })
      //   .then(res => {
      //     (() => {})(res);
      //     if (res.data.code === 200) {
      //       let token = res.data.token;
      //       this.getUserStatusInfo(token);
      //     }
      //   });
    },
    getUserStatusInfo(token) {
      axios
        .get(`${this.$Urls.wpcApiUrl}/Login/ChangePostApi`, { params: {} })
        .then((res) => {
          (() => {})(res);
          if (res.data.code === 200) {
            const { isAdmin, status } = res.data;
            // window.localStorage.clear();
            // location.href = `${this.$Urls.wpcUrl}/choose?token=${token}&staffer_id=${
            //   this.staffer_id
            // }&company_id=${this.company_id}&school_id=${
            //   this.school_id
            // }&status=${status}&isAdmin=${isAdmin}&marketer_id=${
            //   this.marketer_id
            // }`;
          }
        });
    },
    Countdown() {
      let time = setInterval(() => {
        if (this.time > 1) {
          this.time--;
        } else {
          clearInterval(time);
          location.href = `${this.$Urls.wpcUrl}`;
          // this.ComTokenApi();
          // this.$router.push("/home");
        }
      }, 1000);
    },
  },
};
</script>
<style lang="less">
.noPermission {
  height: 100vh;
  font-size: 20px;
  .el-aside {
    display: none;
  }
  .el-main {
    background: #fff;
  }
  .el-header {
    display: none;
  }
}
.page-noPermission {
  text-align: center;
  padding-top: 15%;
  .title {
    font-size: 26px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 37px;
  }
  .img {
    width: 250px;
    background: #fff;
    margin: 0px auto 30px auto;
    padding: 15px 30px;
    img {
      width: 100%;
    }
  }
}
</style>
